<template>
  <div id="create">
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form @submit="onSubmit" class="create-form">
      <div class="" style="width: 90%; margin: 0 auto;">
        <van-field
          v-model="input_content"
          rows="2"
          autosize
          type="textarea"
          placeholder="请输入待解析内容案例：gucci上海恒隆/古驰上海恒隆"
          show-word-limit
        />
        <div style="width: 100px;margin: 5px auto; padding: 2px 0; border-radius: 6px; color: #FFFFFF; border: 1px solid #1989fa; background-color: #1989fa;" @click="explain">智能解析</div>
      </div>
      <div class="create-title">
        <van-field
          readonly
          clickable
          name="picker"
          :value="addForm.city_name"
          label="城市"
          placeholder="城市"
          @click="showCityPicker = true"
        />
        <van-popup v-model="showCityPicker" position="bottom">
          <van-picker
            title="请选择城市"
            show-toolbar
            :columns="cityList"
            value-key="city_cn"
            @confirm="onConfirmCity"
            @cancel="onCancelCity"
            @change="onChangeCity"
            :default-index="addForm.city_index"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="addForm.brand_name"
          label="品牌"
          placeholder="品牌"
          @click="showBrandPicker = true"
        />
        <van-popup v-model="showBrandPicker" position="bottom">
          <van-picker
            title="请选择品牌"
            show-toolbar
            :columns="brandsList"
            value-key="brand_en"
            @confirm="onConfirmBrand"
            @cancel="onCancelBrand"
            @change="onChangeBrand"
            :default-index="addForm.brand_index"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="addForm.market_name"
          label="商场"
          placeholder="商场"
          @click="showMarketPicker = true"
        />
        <van-popup v-model="showMarketPicker" position="bottom">
          <van-picker
            title="请选择商场"
            show-toolbar
            :columns="marketList"
            value-key="market_cn"
            @confirm="onConfirmMarket"
            @cancel="onCancelMarket"
            @change="onChangeMarket"
            :default-index="addForm.market_id"
          />
        </van-popup>
        <van-field
          v-model="addForm.shop_name"
          name="店铺名"
          label="店铺名"
          placeholder="店铺名"
          readonly
          @click="showStorePicker = true"
          :rules="[{ required: true, message: '店铺名' }]"
        />
        <van-popup v-model="showStorePicker" position="bottom">
          <van-picker
            title="请选择店铺名"
            show-toolbar
            :columns="storeList"
            value-key="name_cn"
            @confirm="onConfirmStore"
            @cancel="onCancelStore"
            @change="onChangeStore"
            :default-index="addForm.shop_index"
          />
        </van-popup>
        <van-field
          v-model="addForm.company_en"
          name="公司名"
          label="公司名"
          placeholder="公司名"
          readonly
          @click="showCompanyPicker = true"
          :rules="[{ required: true, message: '公司名' }]"
        />
        <van-popup v-model="showCompanyPicker" position="bottom">
          <van-picker
            title="请选择公司"
            show-toolbar
            :columns="companies"
            value-key="company_en"
            @confirm="onConfirmCompany"
            @cancel="showCompanyPicker = false"
            @change="onChangeCompany"
            :default-index="addForm.company_id"
            :rules="[{ required: true, message: '请选择公司' }]"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="addForm.typeCn"
          label="维修类型"
          placeholder="维修类型"
          @click="showTypePicker = true"
        />
        <van-popup v-model="showTypePicker" position="bottom">
          <van-picker
            title="请选择维修类型"
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
            @change="onChange"
            :default-index="addForm.type"
            :rules="[{ required: true, message: '维修类型' }]"
          />
        </van-popup>
        <van-field
          name="预约日期"
          label="预约日期"
          v-if="addForm.typeCn === '定期维保'"
          placeholder="预约日期"
          readonly
          clickable
          :value="addForm.appo_at"
          @click="showCalendar = true"
        />
        <van-calendar v-model="showCalendar" @confirm="onConfirmDate" />
        <!--<van-cell title="上门开始时间" :value="addForm.start_at" style="text-align: left;" @click="showRepairStartTime = true" />
        <van-popup v-model="showRepairStartTime" position="bottom">
          <van-datetime-picker
            type="datehour"
            title="开始时间"
            :min-date="minDate"
            @cancel="showRepairStartTime = false"
            @confirm="selectStartDate"
          />
        </van-popup>
        <van-cell title="上门结束时间" :value="addForm.end_at" style="text-align: left;" @click="showRepairEndTime = true" />
        <van-popup v-model="showRepairEndTime" position="bottom">
          <van-datetime-picker
            type="datehour"
            title="结束时间"
            :min-date="minDate"
            @cancel="showRepairEndTime = false"
            @confirm="selectEndDate"
          />
        </van-popup>-->
        <van-field
              v-model="addForm.submit_remark"
              rows="3"
              autosize
              label="维修备注"
              type="textarea"
              placeholder="维修备注"
            />
      </div>
      <div id="show-content">
          <van-form validate-first @failed="onFailed" style="margin-bottom: 20px">
            <van-field
              readonly
              clickable
              name="picker"
              :value="addForm.selectedCategory"
              label="维修项目"
              placeholder="选择维修项目"
              @click="showPicker = true"
              :rules="[{ required: true, message: '维修项目' }]"
            />
            <van-popup v-model="showPicker" position="bottom">
            <van-picker
              title="请选择维修项目"
              show-toolbar
              :columns="projects"
              value-key="name"
              @confirm="onConfirmColumn"
              @cancel="onCancelColumn"
              @change="onChangeColumn"
              :default-index="addForm.category_level2"
            />
          </van-popup>
            <van-field
              v-model="addForm.prob_desc"
              rows="3"
              autosize
              label="问题描述"
              type="textarea"
              placeholder="问题描述"
            />
            <div style="overflow: hidden;">
              <div v-for="(item, index) in tips" :key="index" class="order_tips_item" @click="selectTip(item)">{{ item }}</div>
            </div>
            <!--<van-field
              v-model="addForm.location"
              rows="1"
              autosize
              label="报修区域"
              type="textarea"
              placeholder="报修区域"
            />
            <van-field name="uploader" label="上传图片">
              <template #input>
                <van-uploader v-model="imageList"
                              :max-size="4096 * 1024"
                              multiple
                              :before-read="beforeRead"
                              :after-read="onRead"
                              :before-delete="deleteFile"
                              @oversize="onOversize"/>
              </template>
            </van-field>-->
            <!--<van-cell title="选择工人" style="text-align: left;" @click="showWorker()" is-link />
            <div v-if="addForm.selectedWorkers">
              <div v-for="(item, index) in addForm.selectedWorkers" v-bind:key="index" class="order_create_workers">
                <div class="order_create_workers_title">{{ item.worker }}</div>
                <div class="order_create_workers_icon" @click="deleteWorker(index)">
                  <van-icon name="cross" />
                </div>
              </div>
            </div>
            <van-popup v-model="showSelectWorker"
                       position="bottom"
                       :style="{ height: '60%' }"
                       closeable
                       close-icon="close"
            >
                <van-search
                  style="margin-top: 40px"
                  placeholder="搜索用户信息"
                  v-model="searchData"
                  @search="getUserList()"
                  @input="getUserList()"
                  @clear="getUserList()"
                ></van-search>
                <van-checkbox-group
                  ref="checkboxGroup"
                  @change="change"
                  v-model="checkedValue"
                >
                  <van-cell-group>
                    <van-cell
                      v-for="(item, index) in workers"
                      clickable
                      :key="item.worker_id"
                      :title="item.worker"
                      @click="toggle(index)"
                    >
                      <template #right-icon>
                        <van-checkbox :name="item.worker_id" ref="checkboxes" shape="square" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-checkbox-group>
                <van-button native-type="button"  @click="submitSelectedUser" style="width: 150px; border-radius: 10px; position: fixed; bottom: 20px; right: 30%;" type="info">确定</van-button>
            </van-popup>-->
          </van-form>
        </div>
      <div style="margin: 16px;width: 210px; margin: 0 auto;" v-if="showButton">
        <van-button type="info" style="width: 80px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-left: 50px; margin-bottom: 50px;" native-type="submit">提交</van-button>
        <div clear="both"></div>
      </div>
    </van-form>
  </div>
</template>
<script>
import {categoryAll,cityList,brandList,marketList,shopList,getImageOss,createOrder, manCategoryLevel2,searchWorkers} from '@/api/order'
import {Toast} from 'vant'
import OSS from 'ali-oss'
import {
  addStore,
  getBrandList,
  getCityList, getMaCateLv0List,
  getMaCateLv1List,
  getMarketList,
  getOssToken,
  getShopList,
  getTipList, parseAddress
} from "../../api/order";
import {getCompanyList} from "../../api/util";

export default {
  name: 'create',
  data () {
    return {
      addForm: {
        file_ids_arr: [],
        city_id: '',
        city_name: '',
        city_index: '',
        brand_id: '',
        brand_index: '',
        brand_name: '',
        shop_id: '',
        shop_name: '',
        shop_index: '',
        market_id: '',
        market_name: '',
        market_index: '',
        maintained_at: '',
        store: '',
        only_save: true,
        type: 0,
        typeCn: '',
        img_urls: [],
        area: '',
        start_at: '',
        end_at: '',
        selectedWorkers: [],
        man_ids: [],
        prob_desc: ''
      },
      showCompanyPicker: false,
      showBrandPicker: false,
      showStorePicker: false,
      showCalendar: false,
      title: '创建订单',
      minDate: new Date(),
      maxDate: '',
      fileList: [],
      checkedValue: [],
      showPicker: false,
      showTypePicker: false,
      columns: [],
      content: {},
      showContentPicker: false,
      id: undefined,
      contentId: undefined,
      newCreate: true,
      selectedDate: undefined,
      postContent: {
        score: '',
        desc: ''
      },
      showContent: false,
      showButton: true,
      newAdd: true,
      showAddContentPicker: false,
      showRepairEndTime: false,
      showCityPicker: false,
      showRepairStartTime: false,
      showSelectWorker: false,
      showMarketPicker: false,
      workers: [],
      marketList: [],
      cityList: [],
      brandsList: [],
      imageList: [],
      cascaderValue: [],
      storeList: [],
      searchData: '',
      projects: [],
      companies: [],
      tips: [],
      tipContent: '',
      input_content: '',
      submitLoading: false,
      defaultShopList: [
        '无',
        '男装',
        '女装',
        '童装',
        '鞋店'
      ],
      categories: []
    }
  },
  created () {
    this.initCategories()
    this.initAddForm()
    this.initCity()
    this.initBrand()
    this.initColumns()
    this.initCompanies()
    this.getTips()
  },
  methods: {
    explain() {
      if (this.input_content.length <= 0) {
        return false;
      }
      parseAddress({address: this.input_content}).then((res) => {
        console.log('res........', res)
        if (res.data.data) {
          if (res.data.data.brand_id) {
            this.addForm.brand_id = res.data.data.brand_id
            this.addForm.brand_name = res.data.data.brand_en
          } else {
            this.addForm.brand_id = 0
            this.addForm.brand_name = ''
          }
          if (res.data.data.city_id) {
            this.addForm.city_id = res.data.data.city_id
            this.addForm.city_name = res.data.data.city_cn
            this.initMarkets()
          } else {
            this.addForm.city_id = 0
            this.addForm.city_name = ''
          }
          if (res.data.data.market_id) {
            this.addForm.market_id = res.data.data.market_id
            this.addForm.market_name = res.data.data.market_cn
          } else {
            this.addForm.market_id = 0
            this.addForm.market_name = ''
          }
          if (res.data.data.shop_id) {
            this.addForm.shop_id = res.data.data.shop_id
            this.addForm.shop_name = res.data.data.shop_cn
            this.searchStore()
          } else {
            this.addForm.shop_id = 0
            this.addForm.shop_name = ''
          }
        }
      })
    },
    initCategories() {
      getMaCateLv0List().then((res) => {
        if (res.data.data) {
          this.categories = []
          this.columns = []
          for (const item in res.data.data) {
            this.columns.push(res.data.data[item])
            this.categories[res.data.data[item]] = item
          }
        }
      })
    },
    selectTip(val) {
      this.addForm.prob_desc = val
    },
    getTips() {
      getTipList().then((res) => {
        console.log('res.......', res)
        if (res.data.ret) {
          this.tips = res.data.ret
        }
      })
    },
    initCompanies() {
      getCompanyList().then((res) => {
        if (res.data.data) {
          this.companies = res.data.data
        }
      })
    },
    onConfirmCompany(val) {
      console.log('val.....', val)
      this.showCompanyPicker = false
      this.addForm.company_id = val.id
      this.addForm.company_en = val.company_en
    },
    onChangeCompany() {
    },
    showWorker() {
      this.showSelectWorker = true
      this.searchData = ''
    },
    deleteWorker (index) {
      this.addForm.selectedWorkers.splice(index, 1)
    },
    initColumns () {
      getMaCateLv1List({p_type: typeof this.categories[this.addForm.typeCn] !== 'undefined' ? this.categories[this.addForm.typeCn] : '' }).then((res) => {
        if (res.data.data) {
          const data = []
          for (const item in res.data.data) {
            data.push({
              id: res.data.data[item].id,
              name: res.data.data[item].cn_name ? res.data.data[item].cn_name : res.data.data[item].en_name
            })
          }
          this.projects = data
        }
      })
    },
    submitSelectedUser() {
      if (this.checkedValue.length > 0) {
        for (const i in this.checkedValue) {
          if (this.addForm.man_ids.indexOf(this.checkedValue[i]) > -1) {
            continue
          }
          this.addForm.man_ids.push(this.checkedValue[i])
          for (const j in this.workers) {
            if (this.checkedValue[i] === this.workers[j].worker_id) {
              this.addForm.selectedWorkers.push(this.workers[j])
              break
            }
          }
        }
        console.log('32333333', this.addForm.selectedWorkers)
        this.showSelectWorker = false
        this.workers = []
        this.checkedValue = []
      }
    },
    onCancelBrand() {
      this.showBrandPicker = false
    },
    onConfirmBrand(evt) {
      this.addForm.brand_id = evt.id
      this.addForm.brand_name = evt.brand_en
      this.showBrandPicker = false
      this.searchStore()
    },
    onConfirmMarket(evt) {
      this.addForm.market_id = evt.id
      this.addForm.market_name = evt.market_cn
      this.addForm.shop_id = ''
      this.addForm.shop_name = ''
      this.showMarketPicker = false
      this.searchStore()
    },
    onFailed() {

    },
    onChangeBrand() {

    },
    onConfirmCity(evt) {
      this.addForm.city_id = evt.id
      this.addForm.city_name = evt.city_cn
      this.showCityPicker = false
      this.initMarkets()
      this.searchStore()
    },
    onChangeCity(evt) {
      console.log(evt)
    },
    onCancelCity() {
      this.showCityPicker = false
    },
    onOversize (file) {
    },
    beforeRead (file) {
      if (file.length > 1) {
        for (const i in file) {
          if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png' && file[i].type !== 'image/jpg') {
            Toast('请上传图片')
            return false
          }
        }
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
          Toast('请上传图片')
          return false
        }
      }
      return true
    },
    deleteFile (file, index) {
      this.imagePath = []
    },
    async onRead(file) {
      console.log(file)
      if (file.length > 1) {
        for (const i in file) {
          await this.uploadImg(file[i].file)
        }
      } else {
        await this.uploadImg(file.file)
      }
    },
    async uploadImg (file) {
      let fileSuffix = ''
      if (file.type === 'image/jpeg') {
        fileSuffix = 'jpeg'
      }
      if (file.type === 'image/png') {
        fileSuffix = 'png'
      }
      if (file.type === 'image/jpg') {
        fileSuffix = 'jpg'
      }
      await getOssToken({ file_suffix: fileSuffix }).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              this.addForm.file_ids_arr.push(ossData.file_id)
            }
          })
        }
      })
    },
    onChangeMarket() {

    },
    change(evt) {
      console.log('evt...', evt)
    },
    showSubmit() {

    },
    onCancelMarket() {
      this.showMarketPicker = false
    },
    onCancelStore() {
      this.showStorePicker = false
    },
    initCity() {
      getCityList().then((res) => {
        if (res.data.data) {
          console.log('cityList.....', this.cityList)
          this.cityList = res.data.data
        }
      })
    },
    initBrand() {
      getBrandList().then((res) => {
        if (res.data.data) {
          this.brandsList = res.data.data
        }
      })
    },
    onChangeStore() {

    },
    searchStore() {
      getShopList({city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id}).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.storeList = res.data.data
        } else {
          this.storeList = []
          this.storeList[0] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.addForm.city_name + this.addForm.market_name }
          this.storeList[1] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.addForm.city_name + this.addForm.market_name + '男装' }
          this.storeList[2] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.addForm.city_name + this.addForm.market_name + '女装' }
          this.storeList[3] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.addForm.city_name + this.addForm.market_name + '童装' }
          this.storeList[4] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.addForm.city_name + this.addForm.market_name + '鞋店' }
        }
      })
    },
    onConfirmStore(evt) {
      this.addForm.shop_id = evt.id
      this.addForm.shop_name = evt.name_cn
      this.showStorePicker = false
      console.log('evt......', evt)
    },
    getUserList() {
      if (this.searchData !== '' && typeof this.searchData !== 'undefined') {
        searchWorkers({search_str: this.searchData}).then(res => {
          this.workers = res.data.data
        })
      }
    },
    async onSubmit() {
      if (this.submitLoading) {
        Toast('订单提交中，请耐心等待')
        return false
      }
      if (this.addForm.store_id === '') {
        Toast('请选择店铺')
        return false
      }
      if (this.addForm.category_level2 === '' || typeof this.addForm.category_level2 === 'undefined') {
        Toast('缺少维修项目')
        return false
      }
      if (this.addForm.shop_id === 0) {
        const store_info = {
          "store_name_cn": this.addForm.shop_name,
          "brand_id": this.addForm.brand_id,
          "city_id": this.addForm.city_id,
          "market_id": this.addForm.market_id
        }
        await addStore(store_info).then((res) => {
          if (res.data.data) {
            this.addForm.shop_id = res.data.data
          }
        })
      }

      const submit_data = {
        store_id: this.addForm.shop_id,
        ma_type: this.categories[this.addForm.typeCn],
        company_id: this.addForm.company_id,
        appo_at: typeof this.addForm.appo_at !== 'undefined' ? this.addForm.appo_at : '',
        ma_item_list: [
          {
            ma_cate_id: this.addForm.category_level2,
            prob_desc: this.addForm.prob_desc,
            location: this.addForm.location,
            file_ids: this.addForm.file_ids_arr.join(','),
            appo_task_list: [
              {
                ma_start_at: this.addForm.start_at,
                ma_end_at: this.addForm.end_at,
                worker_ids: '', // this.addForm.man_ids.join(','),
                submit_remark: this.addForm.submit_remark
              }
            ]
          }
        ]
      }
      this.submitLoading = true
      await createOrder(submit_data).then((res) => {
        if (res.data.code === 0) {
          Toast('提交成功')
          setTimeout(() => {
            this.$router.push('/warranty_list')
            this.submitLoading = false
          }, 500)
        }
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    formatter (type, val) {
      if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      } else if (type === 'year') {
        return `${val}年`
      }
      return val
    },
    onConfirmDate (val) {
      console.log(val)
      const d = new Date(val)
      const dateTime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      this.addForm.appo_at = dateTime
      this.showCalendar = false
    },
    confirmDate (val) {
      const d = new Date(val)
      const dateTime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      this.addForm.maintained_at = dateTime
      this.showPicker = false
    },
    onConfirm (val, index) {
      this.addForm.typeCn = val
      this.addForm.type = index
      console.log('index...................', index)
      this.showTypePicker = false
      this.initColumns()
      this.selectedCategory = ''
    },
    onCancel (val) {
      this.showTypePicker = false
    },
    cancel () {
      this.showPicker = false
    },
    onChange (val) {
      console.log(val)
    },
    async addDetail () {
      this.showAddContentPicker = false
      this.contentId = undefined
      this.newAdd = false
    },
    async addContent () {
      this.showAddContentPicker = true
      this.contentId = undefined
      this.newAdd = true
    },
    actContent () {
      this.showContentPicker = false
    },
    initAddForm () {
      if (localStorage.getItem('store_name')) {
        this.addForm.store = localStorage.getItem('store_name')
      }
      if (localStorage.getItem('brand_id')) {
        this.addForm.brand_id = localStorage.getItem('brand_id')
      }
      if (localStorage.getItem('shop_id')) {
        this.addForm.shop_id = localStorage.getItem('shop_id')
      }
      const id = this.$route.query.id
      if (id) {

      } else {
        const type = this.$route && this.$route.params && this.$route.params.type ? this.$route.params.type : 0
        this.addForm.type = type
        this.addForm.typeCn = this.columns[type]
      }
    },
    selectStartDate (val) {
      this.showRepairStartTime = false;
      this.addForm.start_at = this.formatDate(val);
    },
    selectEndDate (val) {
      this.showRepairEndTime = false;
      this.addForm.end_at = this.formatDate(val)
    },
    formatDate(date) {
      return  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:00`;
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    initMarkets() {
      getMarketList({city_id: this.addForm.city_id}).then((res) => {
        if (res.data.data) {
          this.marketList = res.data.data
        }
      })
    },
    onConfirmColumn(evt) {
      console.log('firm-column', evt)
      this.addForm.category_level2 = evt.id
      this.addForm.category_level1 = parseInt(this.addForm.type) + 1
      this.addForm.selectedCategory = evt.name
      this.showPicker = false
      this.initColumns()
    },
    onCancelColumn() {

    },
    onChangeColumn() {

    }
  }
}
</script>

<style scoped>
.order_tips_item {
  cursor: pointer;
  padding: 10px 20px;
  float: left;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  border-radius: 20px;
  margin-right: 20px;
  margin-top: 10px;
  background-color: #f8f8f8;
  color: #676767;
}
  .create-form {
    margin-top: 20px;
    border-radius: 1px;
  }
  .create-title {
    border-radius: 80px;
    width: 94%;
    margin: 10px auto;
  }
  #show-content {
    width: 94%;
    margin: 10px auto;
  }
  .order_create_workers {
    overflow: hidden;
    padding: 0 20px;
  }
  .order_create_workers_title {
    float: left;
    margin-left: 20px;
  }
  .order_create_workers_icon {
    margin-left: 20px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/create.vue